import React from 'react';

import { IonIcon } from '@ionic/react';

import Button from 'components/Button';
import { useModal } from 'components/Modal';
import { useScreenDispatch, useScreenState } from 'components/Screen';
import { useQuery } from 'query';
import { COLUMNS } from 'scenes/PerformancePage/constants';
import { columns } from 'scenes/PerformancePage/data/queryKeyFactory';
import { SET_COLUMNS } from 'scenes/PerformancePage/screenReducer';
import { loadColumns } from 'scenes/PerformancePage/sources/loadColumns';

import Columns from './Columns';
import './index.css';

const ColumnsPicker = () => {
  const screenState = useScreenState();
  const dispatch = useScreenDispatch();
  const { data, error } = useQuery(columns, () => loadColumns());

  const [showColumnsModal] = useModal(Columns, {
    value: screenState[COLUMNS],
    data: data,
    error: error,
  });

  const openColumns = () => {
    showColumnsModal({
      onSubmit: (value: number[]) => {
        dispatch({
          type: SET_COLUMNS,
          payload: value,
        });
      },
    });
  };

  return (
    <div className={'columns-picker'}>
      <Button onClick={openColumns}>
        <IonIcon slot={'icon-only'} name={'view-column'} />
      </Button>
    </div>
  );
};
export default ColumnsPicker;
